import type { ExternalLinksModel } from "@/models";
import { defineStore } from "pinia";

export const useExternalLinksStore = defineStore("externalLinks", {
    state: (): ExternalLinksModel => {
        return {
            keyInformationLinks: [
                {
                    // eslint-disable-next-line max-len
                    linkUrl:
                        "https://www.legalandgeneral.com/landg-assets/personal/life-cover/_resources/over-50s/documents/fixed-policy-summary.pdf",
                    displayName: "Policy Summary",
                    keyName: "policyDoc1",
                },
                {
                    // eslint-disable-next-line max-len
                    linkUrl:
                        "https://www.legalandgeneral.com/landg-assets/personal/life-cover/_resources/over-50s/documents/terms-and-conditions.pdf",
                    displayName: "Policy Terms and Conditions",
                    keyName: "policyDoc2",
                },
            ],
            privacyNotice: {
                displayName: "Privacy Notice",
                linkUrl: "https://www.legalandgeneral.com/privacy-policy/",
            },
            // eslint-disable-next-line max-len
            wellBeingSupport:
                "https://www.legalandgeneral.com/landg-assets/personal/life-cover/_resources/over-50s/documents/wellbeing-support-guide.pdf",
            // eslint-disable-next-line max-len
            marksAndSpencer:
                "https://www.legalandgeneral.com/life-cover/over-50s/marks-and-spencer/",
            // eslint-disable-next-line max-len
            demandsAndNeeds:
                "https://www.legalandgeneral.com/landg-assets/personal/life-cover/_resources/over-50s/documents/idd50.pdf",
            // eslint-disable-next-line max-len
            termsAndConditions:
                "https://www.legalandgeneral.com/landg-assets/personal/life-cover/_resources/over-50s/documents/terms-and-conditions.pdf",
            // eslint-disable-next-line max-len
            policySummary:
                "https://www.legalandgeneral.com/landg-assets/personal/life-cover/_resources/over-50s/documents/fixed-policy-summary.pdf",
            fairProcessingNotice: "https://www.cifas.org.uk/fpn",
        };
    },
});
